import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  public currentLang: string = 'es';

  constructor(private translate: TranslateService) {
    // Defina o idioma padrão
    this.currentLang = localStorage.getItem('language') && localStorage.getItem('language') !== '' 
      ? localStorage.getItem('language')! 
      : this.currentLang;

    this.translate.setDefaultLang(this.currentLang);
  }

  changeLanguage(language: string) {
    // Altere o idioma atual
    this.currentLang = language;
    this.translate.use(language);
    localStorage.setItem('language', this.currentLang);
  }
}